import type { ThemeId } from "./types";

export interface ThemeDefinition {
  id: ThemeId;
  name: string;
  description: string;
  logo: string;
  favicon: string;
  appleTouchIcon: string;
  manifest: string;
  themeColor: string;
  swatches: string[];
}

export const BRAND_ASSET_VERSION = "e552917a274c";

const THEME_DEFINITIONS: ThemeDefinition[] = [
  {
    id: "aurora",
    name: "Aurore",
    description: "Clair, végétal et chaleureux",
    logo: "/brand/nora-aurora.webp",
    favicon: "/brand/favicon-aurora.png",
    appleTouchIcon: "/brand/apple-touch-icon-aurora.png",
    manifest: "/manifest-aurora.webmanifest",
    themeColor: "#f4f6f1",
    swatches: ["#f4f6f1", "#176b5c", "#2d6d91", "#bd6248"],
  },
  {
    id: "nocturne",
    name: "Nocturne",
    description: "Sombre, contrasté et lumineux",
    logo: "/brand/nora-nocturne.webp",
    favicon: "/brand/favicon-nocturne.png",
    appleTouchIcon: "/brand/apple-touch-icon-nocturne.png",
    manifest: "/manifest-nocturne.webmanifest",
    themeColor: "#101718",
    swatches: ["#101718", "#5bc2a8", "#6ab8df", "#ef8b67"],
  },
  {
    id: "titanium",
    name: "Titane",
    description: "Clair, froid et technique",
    logo: "/brand/nora-titanium.webp",
    favicon: "/brand/favicon-titanium.png",
    appleTouchIcon: "/brand/apple-touch-icon-titanium.png",
    manifest: "/manifest-titanium.webmanifest",
    themeColor: "#e8edf1",
    swatches: ["#e8edf1", "#334e5c", "#315f85", "#b65e52"],
  },
  {
    id: "graphite",
    name: "Graphite",
    description: "Sombre, neutre et ambré",
    logo: "/brand/nora-graphite.webp",
    favicon: "/brand/favicon-graphite.png",
    appleTouchIcon: "/brand/apple-touch-icon-graphite.png",
    manifest: "/manifest-graphite.webmanifest",
    themeColor: "#151719",
    swatches: ["#151719", "#8abf9b", "#8fc4df", "#dba45a"],
  },
  {
    id: "borealis",
    name: "Boréale",
    description: "Sombre, polaire et menthe",
    logo: "/brand/nora-borealis.webp",
    favicon: "/brand/favicon-borealis.png",
    appleTouchIcon: "/brand/apple-touch-icon-borealis.png",
    manifest: "/manifest-borealis.webmanifest",
    themeColor: "#0f1822",
    swatches: ["#0f1822", "#69d2ad", "#78b9ff", "#e98886"],
  },
  {
    id: "solar",
    name: "Solaire",
    description: "Clair, énergique et indigo",
    logo: "/brand/nora-solar.webp",
    favicon: "/brand/favicon-solar.png",
    appleTouchIcon: "/brand/apple-touch-icon-solar.png",
    manifest: "/manifest-solar.webmanifest",
    themeColor: "#f5f4ed",
    swatches: ["#f5f4ed", "#34836c", "#405fc0", "#d96a52"],
  },
  {
    id: "coral",
    name: "Corail",
    description: "Clair, doux et contrasté",
    logo: "/brand/nora-coral.webp",
    favicon: "/brand/favicon-coral.png",
    appleTouchIcon: "/brand/apple-touch-icon-coral.png",
    manifest: "/manifest-coral.webmanifest",
    themeColor: "#f7eded",
    swatches: ["#f7eded", "#347a78", "#355d7a", "#c8555c"],
  },
  {
    id: "plasma",
    name: "Plasma",
    description: "Sombre, magenta et cyan",
    logo: "/brand/nora-plasma.webp",
    favicon: "/brand/favicon-plasma.png",
    appleTouchIcon: "/brand/apple-touch-icon-plasma.png",
    manifest: "/manifest-plasma.webmanifest",
    themeColor: "#120f1b",
    swatches: ["#120f1b", "#62c9ad", "#57c7e8", "#bd78ed"],
  },
  {
    id: "terminal",
    name: "Terminal",
    description: "Sombre, vert et ambre",
    logo: "/brand/nora-terminal.webp",
    favicon: "/brand/favicon-terminal.png",
    appleTouchIcon: "/brand/apple-touch-icon-terminal.png",
    manifest: "/manifest-terminal.webmanifest",
    themeColor: "#0d1310",
    swatches: ["#0d1310", "#62d486", "#7fb3a1", "#e2ad4f"],
  },
  {
    id: "arctic",
    name: "Arctique",
    description: "Clair, glacé et cobalt",
    logo: "/brand/nora-arctic.webp",
    favicon: "/brand/favicon-arctic.png",
    appleTouchIcon: "/brand/apple-touch-icon-arctic.png",
    manifest: "/manifest-arctic.webmanifest",
    themeColor: "#edf4f7",
    swatches: ["#edf4f7", "#24745f", "#3976a8", "#d25c57"],
  },
  {
    id: "rose",
    name: "Quartz rose",
    description: "Clair, sensuel et minéral",
    logo: "/brand/nora-rose.webp",
    favicon: "/brand/favicon-rose.png",
    appleTouchIcon: "/brand/apple-touch-icon-rose.png",
    manifest: "/manifest-rose.webmanifest",
    themeColor: "#f5e9ee",
    swatches: ["#f5e9ee", "#2f7f84", "#6a5575", "#b84f77"],
  },
  {
    id: "sapphire",
    name: "Saphir",
    description: "Sombre, royal et électrique",
    logo: "/brand/nora-sapphire.webp",
    favicon: "/brand/favicon-sapphire.png",
    appleTouchIcon: "/brand/apple-touch-icon-sapphire.png",
    manifest: "/manifest-sapphire.webmanifest",
    themeColor: "#0c1528",
    swatches: ["#0c1528", "#58bd9d", "#4d83e5", "#d9a84e"],
  },
  {
    id: "ember",
    name: "Braise",
    description: "Sombre, ardent et ambré",
    logo: "/brand/nora-ember.webp",
    favicon: "/brand/favicon-ember.png",
    appleTouchIcon: "/brand/apple-touch-icon-ember.png",
    manifest: "/manifest-ember.webmanifest",
    themeColor: "#17100f",
    swatches: ["#17100f", "#66c79d", "#f0b85a", "#e35d48"],
  },
  {
    id: "ivory",
    name: "Ivoire",
    description: "Clair, précieux et discret",
    logo: "/brand/nora-ivory.webp",
    favicon: "/brand/favicon-ivory.png",
    appleTouchIcon: "/brand/apple-touch-icon-ivory.png",
    manifest: "/manifest-ivory.webmanifest",
    themeColor: "#f7f5ef",
    swatches: ["#f7f5ef", "#257a78", "#59606a", "#a8843e"],
  },
  {
    id: "ocean",
    name: "Océan",
    description: "Sombre, profond et turquoise",
    logo: "/brand/nora-ocean.webp",
    favicon: "/brand/favicon-ocean.png",
    appleTouchIcon: "/brand/apple-touch-icon-ocean.png",
    manifest: "/manifest-ocean.webmanifest",
    themeColor: "#0b1a1d",
    swatches: ["#0b1a1d", "#3bb7b3", "#5ccbd0", "#ef8e6c"],
  },
  {
    id: "orchid",
    name: "Orchidée",
    description: "Clair, mystique et floral",
    logo: "/brand/nora-orchid.webp",
    favicon: "/brand/favicon-orchid.png",
    appleTouchIcon: "/brand/apple-touch-icon-orchid.png",
    manifest: "/manifest-orchid.webmanifest",
    themeColor: "#f3edf6",
    swatches: ["#f3edf6", "#347f88", "#9368ba", "#c56387"],
  },
  {
    id: "sandstone",
    name: "Sandstone",
    description: "Clair, minéral et chaleureux",
    logo: "/brand/nora-sandstone.webp",
    favicon: "/brand/favicon-sandstone.png",
    appleTouchIcon: "/brand/apple-touch-icon-sandstone.png",
    manifest: "/manifest-sandstone.webmanifest",
    themeColor: "#efe8dd",
    swatches: ["#efe8dd", "#2f756c", "#3e627f", "#b9654a"],
  },
];

export const THEMES: ThemeDefinition[] = THEME_DEFINITIONS.map((theme) => ({
  ...theme,
  logo: versionAsset(theme.logo),
  favicon: versionAsset(theme.favicon),
  appleTouchIcon: versionAsset(theme.appleTouchIcon),
  manifest: versionAsset(theme.manifest),
}));

export function getTheme(themeId: ThemeId): ThemeDefinition {
  return THEMES.find((theme) => theme.id === themeId) ?? THEMES[0]!;
}

export function readStoredTheme(): ThemeId {
  const value = localStorage.getItem("nora.theme");
  return THEMES.some((theme) => theme.id === value) ? value as ThemeId : "aurora";
}

export function applyTheme(themeId: ThemeId): void {
  const theme = getTheme(themeId);
  document.documentElement.dataset.theme = theme.id;
  document.documentElement.style.setProperty("--nora-logo-image", `url("${theme.logo}")`);
  localStorage.setItem("nora.theme", theme.id);
  updateHref("nora-favicon", theme.favicon);
  updateHref("nora-apple-touch-icon", theme.appleTouchIcon);
  updateHref("nora-manifest", theme.manifest);
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute("content", theme.themeColor);
}

function updateHref(id: string, href: string): void {
  document.getElementById(id)?.setAttribute("href", href);
}

function versionAsset(path: string): string {
  return `${path}?v=${BRAND_ASSET_VERSION}`;
}
